
const APP_STATUS_CLOSED_MODAL = 'APP_STATUS_CLOSED_MODAL';
const CANCEL_APP_MODAL = 'CANCEL_APP_MODAL';
const CHANGE_PLANS_MODAL = 'CHANGE_PLANS_MODAL';
const CREATE_TICKET_MODAL = 'CREATE_TICKET_MODAL';
const EXEMPTION_NUMBER_MODAL = 'EXEMPTION_NUMBER_MODAL';
const FAILURE_MODAL = 'FAILURE_MODAL';
const FILE_SIZE_EXCEEDING_ERROR_MODAL = 'FILE_SIZE_EXCEEDING_ERROR_MODAL';
const GET_ASSISTANCE = 'GET_ASSISTANCE';
const MAILING_ADDRESS_UPDATING_MODAL = 'MAILING_ADDRESS_UPDATING_MODAL';
const OVERRIDE_COMMENT_MODAL = 'OVERRIDE_COMMENT_MODAL';
const PICK_DIFF_PLAN = 'PICK_DIFF_PLAN';
const QHP_INELIGIBLE_MODAL = 'QHP_INELIGIBLE_MODAL';
const REUSE_PRIOR_APP = 'REUSE_PRIOR_APP';
const VERIFY_PHONE_MODAL = 'VERIFY_PHONE_MODAL';
const CHANGE_PHONE_MODAL = 'CHANGE_PHONE_MODAL';
const CHANGE_EMAIL_MODAL = 'CHANGE_EMAIL_MODAL';

export const dashboardModalTypes = {
    CHANGE_PLANS_MODAL,
    CHANGE_EMAIL_MODAL,
    CHANGE_PHONE_MODAL,
    VERIFY_PHONE_MODAL,
    APP_STATUS_CLOSED_MODAL,
    CANCEL_APP_MODAL,
    CREATE_TICKET_MODAL,
    EXEMPTION_NUMBER_MODAL,
    FAILURE_MODAL,
    FILE_SIZE_EXCEEDING_ERROR_MODAL,
    GET_ASSISTANCE,
    MAILING_ADDRESS_UPDATING_MODAL,
    OVERRIDE_COMMENT_MODAL,
    PICK_DIFF_PLAN,
    QHP_INELIGIBLE_MODAL,
    REUSE_PRIOR_APP,
};
